import { VersionedAbstractEntity } from "../VersionedAbstractEntity";
export default class ProtocolContentType extends VersionedAbstractEntity {
    name;
    schema = [];
    peerDependencies;
    constructor(protocolContentType = {}) {
        super();
        Object.assign(this, protocolContentType);
    }
}
//# sourceMappingURL=ProtocolContentType.js.map